export const INTEGRATION_TYPES = {
  AWS: "AWS",
  SAP_SUCCESS_FACTORS: "SapSuccessFactors",
} as const;
